(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('filterMultiSelect', {
            templateUrl: 'app/components/filter-multi-select/filter-multi-select.html',
            controller: filterMultiSelectController,
            bindings: {
                name: '@',
                inputType: '@?',
                options: '=?',
                findOptionsApi: '&?',
                loadOptionsErrorMessage: '@?',
                valueMap: '<?',
                totalItems: '=?',
                pageIndex: '=?',
                readOnly: '<?',
                placeholder: '@?',
                model: '=',
                leftPosition: '<?',
                actionOnClose: '&?',
                fullscreen: '<?',
                hasSearch: '<?',
                selectAllOnInit: '<?',
                selectAllOption: '<?',
                isFemaleNoun: '<?'
            }
        });

    /** @ngInject */
    function filterMultiSelectController($translate, $element, $timeout, $window, $scope, toastr, Principal) {
        var $ctrl = this;

        var inputTypes = ['button', 'field'];
        var defaultInputType = 'button';

        var defaultValueMap = {'id': 'id', 'label': 'label', 'value': 'value'};
        var selectedDisplayLabelCount = 1;
        var selectScrollPageSize = 10;

        var isSellerFilter = $ctrl.name === 'sellersFilter';
        var loggedUserId = null;
        var loggedUserName = '';

        $ctrl.hasSearch = $ctrl.hasSearch || false;
        $ctrl.searchText = '';
        $ctrl.isMobile = window.innerWidth <= 768;
        $ctrl.totalItems = $ctrl.totalItems || 0;
        $ctrl.pageIndex = $ctrl.pageIndex || 0;
        var paginationOptions = {
            page: $ctrl.pageIndex,
            size: selectScrollPageSize
        };
        $ctrl.loading = false;
        $ctrl.readOnly = $ctrl.readOnly || false;

        $element.on('hidden.bs.dropdown', function () {
            if ($ctrl.actionOnClose) {
                $ctrl.actionOnClose();
            }
        });

        $ctrl.applySelection = function () {
            if ($ctrl.actionOnClose) {
                $ctrl.actionOnClose();
            }
        }

        $ctrl.$onInit = function () {
            $ctrl.name = $ctrl.name || 'filterMultiSelect-' + new Date().getTime();
            $ctrl.inputType = $ctrl.inputType && inputTypes.includes($ctrl.inputType) ? $ctrl.inputType : defaultInputType;
            $ctrl.options = $ctrl.options || [];
            $ctrl.findOptionsApi = findBindingBaseFunction($ctrl.findOptionsApi);
            $ctrl.isOptionsFromApi = angular.isFunction($ctrl.findOptionsApi);
            $ctrl.loadOptionsErrorMessage = $ctrl.loadOptionsErrorMessage || undefined;
            $ctrl.valueMap = $ctrl.valueMap || defaultValueMap;
            $ctrl._selectedCache = {};
            $ctrl.optionIdKey = Object.keys($ctrl.valueMap).find(function (key) {
                return key === 'id';
            });
            $ctrl.optionLabelKey = Object.keys($ctrl.valueMap).find(function (key) {
                return key === 'label';
            });
            $ctrl.optionValueKey = Object.keys($ctrl.valueMap).find(function (key) {
                return key === 'value';
            });
            $ctrl.placeholder = $ctrl.placeholder || undefined;
            $ctrl.leftPosition = $ctrl.leftPosition || false;
            $ctrl.actionOnClose = $ctrl.actionOnClose || undefined;
            $ctrl.fullscreen = $ctrl.fullscreen || false;
            $ctrl.hasSearch = $ctrl.hasSearch || false;
            $ctrl.selectAllOnInit = $ctrl.selectAllOnInit || false;
            $ctrl.selectAllOption = $ctrl.selectAllOption || false;
            $ctrl.isFemaleNoun = $ctrl.isFemaleNoun || false;
            $ctrl.model = $ctrl.model || getDefaultModel();

            if (isSellerFilter) {
                Principal.identity().then(function(account) {
                    loggedUserId = account.id;
                    loggedUserName = account.fullName;
                });
            }

            if ($ctrl.isOptionsFromApi) {
                if ($ctrl.selectAllOnInit) {
                    $ctrl.model.all = true;
                }

                if (!$ctrl.options || $ctrl.options.length === 0) {
                    fetchFilterOptionsFromCallback();
                }

                if ($ctrl.hasSearch) {
                    $scope.$watch('$ctrl.searchText', function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            paginationOptions.page = 0;
                            fetchFilterOptionsFromCallback();
                        }
                    });
                }
            } else if (angular.isArray($ctrl.options) && $ctrl.options.length > 0) {
                $ctrl.options = formatOptionsDict($ctrl.options);
                if ($ctrl.selectAllOnInit && $ctrl.model.length === 0) {
                    $ctrl.model = angular.copy($ctrl.options);
                }
            }
        };

        $ctrl.getAllSelectedText = function () {
            var translateKey = $ctrl.isFemaleNoun ? 'global.form.all-female' : 'global.form.all';
            return $translate.instant(translateKey);
        }

        $ctrl.toggleSelection = function (option) {
            if ($ctrl.selectAllOption && $ctrl.isOptionsFromApi) {
                if (!angular.isObject($ctrl.model)) {
                    $ctrl.model = getSelectAllPaginatedModel();
                }

                if ($ctrl.model.all) {
                    var exceptIndex = $ctrl.model.except.findIndex(function (item) {
                        if ($ctrl.optionValueKey) {
                            return item === option[$ctrl.optionValueKey];
                        } else if ($ctrl.optionIdKey) {
                            return item === option[$ctrl.optionIdKey];
                        } else {
                            return item === option;
                        }
                    });

                    if (exceptIndex > -1) {
                        $ctrl.model.except.splice(exceptIndex, 1);
                    } else {
                        if ($ctrl.model.except.length === $ctrl.totalItems - 1) {
                            $ctrl.model.except = [];
                            $ctrl.model.all = false;
                        } else if ($ctrl.optionValueKey) {
                            $ctrl.model.except.push(option[$ctrl.optionValueKey]);
                        } else if ($ctrl.optionIdKey) {
                            $ctrl.model.except.push(option[$ctrl.optionIdKey]);
                        } else {
                            $ctrl.model.except.push(option);
                        }
                    }
                } else {
                    var selectedIndex = $ctrl.model.only.findIndex(function (item) {
                        if ($ctrl.optionValueKey) {
                            return item === option[$ctrl.optionValueKey];
                        }
                        else if ($ctrl.optionIdKey) {
                            return item === option[$ctrl.optionIdKey];
                        } else {
                            return item === option;
                        }
                    });

                    if (selectedIndex > -1) {
                        $ctrl.model.only.splice(selectedIndex, 1);
                    } else if ($ctrl.optionValueKey) {
                        $ctrl.model.only.push(option[$ctrl.optionValueKey]);
                    } else if ($ctrl.optionIdKey) {
                        $ctrl.model.only.push(option[$ctrl.optionIdKey]);
                    } else {
                        $ctrl.model.only.push(option);
                    }
                }
            } else {
                if (!angular.isArray($ctrl.model)) {
                    $ctrl.model = [];
                }

                var index = $ctrl.model.findIndex(function (item) {
                    return item.id === option.id;
                });

                if (index > -1) {
                    $ctrl.model.splice(index, 1);
                } else {
                    $ctrl.model.push(option);
                }
            }
        };

        $ctrl.isSelected = function (option) {
            if ($ctrl.selectAllOption && $ctrl.isOptionsFromApi) {
                if ($ctrl.model.all) {
                    return !$ctrl.model.except.some(function (item) {
                        if (angular.isObject(item)) {
                            return item[$ctrl.optionValueKey] === option[$ctrl.optionValueKey] || item.id === option.id;
                        }
                        if ($ctrl.optionValueKey) {
                            return item === option[$ctrl.optionValueKey];
                        } else if ($ctrl.optionIdKey) {
                            return item === option[$ctrl.optionIdKey];
                        } else {
                            return item === option;
                        }
                    });
                } else {
                    return $ctrl.model.only.some(function (item) {
                        if (angular.isObject(item)) {
                            return item[$ctrl.optionValueKey] === option[$ctrl.optionValueKey] || item.id === option.id;
                        }
                        if ($ctrl.optionValueKey) {
                            return item === option[$ctrl.optionValueKey];
                        } else if ($ctrl.optionIdKey) {
                            return item === option[$ctrl.optionIdKey];
                        } else {
                            return item === option;
                        }
                    });
                }
            } else {
                return angular.isArray($ctrl.model) && $ctrl.model.some(function (item) {
                    if (angular.isObject(item)) {
                        return item.id === option.id;
                    }
                    return item === option.id || item === option;
                });
            }
        };

        $ctrl.getPlaceholderText = function () {
            if ($ctrl.hasAnySelected()) {
                return $translate.instant($ctrl.placeholder) + ' | ';
            } else {
                return $translate.instant($ctrl.placeholder);
            }
        };

        $ctrl.getSelectedText = function () {
            if ($ctrl.selectAllOption && $ctrl.isAllSelected()) {
                return $translate.instant($ctrl.getAllSelectedText());
            }

            if ($ctrl.model && $ctrl.selectAllOption && $ctrl.isOptionsFromApi) {
                if ($ctrl.model.firstSelected) {
                    var labelKey = $ctrl.valueMap[$ctrl.optionLabelKey];
                    return $ctrl.model.firstSelected[labelKey] || '';
                }

                if ($ctrl.model.only && $ctrl.model.only.length > 0) {
                    var firstKey = $ctrl.model.only[0];

                    var cached = $ctrl._selectedCache[angular.isObject(firstKey) ? firstKey[$ctrl.optionValueKey] || firstKey.id : firstKey];
                    if (cached) {
                        return cached[$ctrl.optionLabelKey];
                    }

                    if (angular.isObject(firstKey)) {
                        return firstKey[$ctrl.optionLabelKey] || firstKey.name || firstKey.label || '';
                    }

                    if (firstKey === loggedUserId && isSellerFilter) {
                        return loggedUserName;
                    }

                    return firstKey;
                }

                if ($ctrl.model.all) {
                    var labelKeyAll = $ctrl.optionLabelKey;

                    var firstAvailable =
                        Object.values($ctrl._selectedCache).find(function (opt) {
                            var value = opt[$ctrl.optionValueKey];
                            return !$ctrl.model.except.includes(value);
                        });

                    if (firstAvailable) {
                        return firstAvailable[labelKeyAll];
                    }

                    return '';
                }
            }

            if (angular.isArray($ctrl.model) && $ctrl.model.length > 0) {
                var first = $ctrl.model[0];
                return first && first[$ctrl.optionLabelKey] ? first[$ctrl.optionLabelKey] : '';
            }

            return '';
        };

        $ctrl.hasAnySelected = function () {
            var hasModel = !!$ctrl.model;
            var hasSelectAllPaginated = $ctrl.isOptionsFromApi && $ctrl.selectAllOption;
            var hasAnySelected = false;
            if (hasModel) {
                if (hasSelectAllPaginated) {
                    hasAnySelected = ($ctrl.model.all || ($ctrl.model.only && $ctrl.model.only.length > 0));
                } else {
                    hasAnySelected = angular.isArray($ctrl.model) && $ctrl.model.length > 0;
                }
            }
            return hasAnySelected;
        }

        $ctrl.clearSelection = function ($event) {
            $event.stopPropagation();
            $ctrl.model = getDefaultModel();

            if (typeof $ctrl.actionOnClose === 'function') {
                $timeout(function () {
                    $ctrl.actionOnClose();
                }, 0);
            }
        };

        $ctrl.isAllSelected = function () {
            if ($ctrl.model && $ctrl.selectAllOption && $ctrl.isOptionsFromApi) {
                return $ctrl.model.all && (!$ctrl.model.except || $ctrl.model.except.length === 0);
            } else {
                return angular.isArray($ctrl.model) && angular.isArray($ctrl.options) && $ctrl.model.length === $ctrl.options.length;
            }
        };

        $ctrl.isIndeterminate = function () {
            if($ctrl.selectAllOption && $ctrl.isOptionsFromApi) {
                var hasExceptions = $ctrl.model.all && $ctrl.model.except && $ctrl.model.except.length > 0;
                var hasSomeButNotAllSelected =
                    !$ctrl.model.all && $ctrl.model.only && $ctrl.model.only.length > 0 &&
                    $ctrl.model.only.length < $ctrl.totalItems
                return hasExceptions || hasSomeButNotAllSelected;
            } else {
                return angular.isArray($ctrl.model) && $ctrl.model.length > 0 &&
                    $ctrl.model.length !== $ctrl.options.length;
            }
        };

        $ctrl.toggleSelectAll = function () {
            if ($ctrl.selectAllOption && $ctrl.isOptionsFromApi) {
                var allSelected = $ctrl.isAllSelected();
                $ctrl.model = getSelectAllPaginatedModel();
                $ctrl.model.all = !allSelected;
            } else {
                if ($ctrl.isAllSelected()) {
                    $ctrl.model = [];
                } else {
                    $ctrl.model = angular.copy($ctrl.options);
                }
            }
        };

        $ctrl.fetchNextPage = function () {
            if (!$ctrl.loading && $ctrl.isOptionsFromApi) {
                if (($ctrl.options.length < $ctrl.totalItems)) {
                    $ctrl.pageIndex++;
                    paginationOptions.page = $ctrl.pageIndex;
                    fetchFilterOptionsFromCallback();
                }
            }
        }

        $ctrl.getSelectedPlusCount = function () {
            var selectedCount;
            if ($ctrl.selectAllOption && $ctrl.isOptionsFromApi) {
                if ($ctrl.model.all) {
                    selectedCount = $ctrl.totalItems - $ctrl.model.except.length;
                } else {
                    selectedCount = $ctrl.model.only.length;
                }
            } else {
                selectedCount = $ctrl.model.length;
            }

            return selectedCount > selectedDisplayLabelCount ?
                ' ' + $translate.instant('global.form.selected-plus',
                    { count: selectedCount - selectedDisplayLabelCount }) : '';
        }

        function formatOptionsDict(optionsDict) {
            return formatSelectOptions(optionsDict);
        }

        function fetchFilterOptionsFromCallback() {
            $ctrl.loading = true;
            if (angular.isFunction($ctrl.findOptionsApi)) {
                $ctrl.findOptionsApi(
                    paginationOptions,
                    $ctrl.searchText,
                    onSuccessFetchFilterOptionsFromCallback,
                    onErrorFetchFilterOptionsFromCallback
                );
            } else {
                $ctrl.loading = false;
            }
        }

        function onSuccessFetchFilterOptionsFromCallback(response) {
            if (response && response.data) {
                var responsePage;
                if (angular.isArray(response.data.content)) { // Response is Page
                    responsePage = response.data.content;
                    $ctrl.totalItems = response.data.totalElements || 0;
                } else if (angular.isArray(response.data)) { // Response is List
                    responsePage = response.data;
                    $ctrl.totalItems = response.headers['x-total-count'] || 0;
                }

                if (responsePage !== undefined) {

                    var mappedOptions = responsePage.map(mapResponseItemToOption);
                    if (paginationOptions.page === 0) {
                        $ctrl.options = mappedOptions;
                    } else {
                        $ctrl.options = $ctrl.options.concat(mappedOptions);
                    }

                    mappedOptions.forEach(function(opt) {
                        var key = opt[$ctrl.optionValueKey];
                        if (key !== undefined) {
                            $ctrl._selectedCache[key] = opt;
                        }
                    });
                }
            } else {
                $ctrl.options = [];
            }

            $ctrl.loading = false;

            function mapResponseItemToOption(item) {
                var mappedItem = {};
                var selectModelKeys = $ctrl.valueMap ? Object.keys($ctrl.valueMap) : [];
                selectModelKeys.forEach(function (selectModelKey) {
                    mapItemProperty(mappedItem, selectModelKey, item, $ctrl.valueMap[selectModelKey]);
                });
                return mappedItem;
            }

            function mapItemProperty(currentMappedProperty, currentKey, item, itemPropertyKey) {
                var keySeparatorIndex = currentKey.indexOf('.');
                var hasSubKey = keySeparatorIndex !== -1;
                if (!hasSubKey) {
                    currentMappedProperty[currentKey] = fetchProperty(item, itemPropertyKey);
                } else {
                    var currentPropertyKey = currentKey.substring(0, keySeparatorIndex);
                    var subKey = currentKey.substring(keySeparatorIndex + 1);
                    if (!currentMappedProperty.hasOwnProperty(currentPropertyKey)) {
                        currentMappedProperty[currentPropertyKey] = {};
                    }
                    mapItemProperty(currentMappedProperty[currentPropertyKey], subKey, item, itemPropertyKey);
                }
            }

            function fetchProperty(item, propertyKey) {
                var keySeparatorIndex = propertyKey.indexOf('.');
                var hasSubKey = keySeparatorIndex !== -1;
                if (!hasSubKey) {
                    return item.hasOwnProperty(propertyKey) ? item[propertyKey] : undefined;
                } else {
                    var currentPropertyKey = propertyKey.substring(0, keySeparatorIndex);
                    var subKey = propertyKey.substring(keySeparatorIndex + 1);
                    if (item.hasOwnProperty(currentPropertyKey)) {
                        return fetchProperty(item[currentPropertyKey], subKey);
                    } else {
                        return undefined;
                    }
                }
            }
        }

        function onErrorFetchFilterOptionsFromCallback() {
            if ($ctrl.loadOptionsErrorMessage) {
                toastr.error($ctrl.loadOptionsErrorMessage);
            }
            $ctrl.loading = false;
        }

        function getDefaultModel() {
            if ($ctrl.selectAllOption && $ctrl.isOptionsFromApi) {
                return getSelectAllPaginatedModel();
            } else {
                return [];
            }
        }
    }
})();
